export default __webpack_public_path__ + "static/media/fad-preset-ab.8903e29c.svg";